import React from 'react'
import '../i18n' // Import i18n config
import 'leaflet/dist/leaflet.css'
import './application.css'
import { createRoot } from 'react-dom/client'
import App from '../components/App'

import { initFlash } from '../utils/flash'

const containerId = 'root'
let root = null

const mountApp = () => {
  // Init flash messages globally
  initFlash()

  const container = document.getElementById(containerId)

  if (container) {
    // If a root already exists, unmount it first (though in Turbo, the container is usually fresh)
    // Actually, createRoot on a new container is fine. If container is reused, we might need warning checks.
    // In Turbo Drive, the Body is assumed to be replaced, so 'container' is a new DOM node.
    // But 'root' variable persists in module scope.

    console.log('Found root container, mounting React app...')
    let currentUser = null
    try {
      const data = container.getAttribute('data-current-user')
      console.log('Current user data:', data)
      currentUser = data ? JSON.parse(data) : null
    } catch (e) {
      console.error('Failed to parse current user:', e)
    }

    if (root) {
      root.unmount()
      root = null
    }

    root = createRoot(container)
    root.render(<App currentUser={currentUser} />)
  } else {
    // console.log('Root container not found (normal if not on home page)')
  }
}

// Global PWA Install Prompt Capture
window.addEventListener('beforeinstallprompt', (e) => {
  // Prevent the mini-infobar from appearing on mobile
  e.preventDefault()
  // Stash the event so it can be triggered later.
  window.deferredPWAInstallPrompt = e
})

// 1. Run on Turbo navigation (and initial load if caught in time)
document.addEventListener('turbo:load', mountApp)

// 2. Run immediately if DOM is already ready (in case we missed the event or Turbo isn't active)
// This fixes the "Black Screen" on initial load/refresh if the script runs after the event.
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  mountApp()
} else {
  document.addEventListener('DOMContentLoaded', mountApp)
}
